import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getVacancyByFriendlyUrlAPI from '../../api/get-vacancy-by-friendly-url';
import getVacancyByIdForUrlAPI from '../../api/get-vacancy-by-id-for-url';
import { IVacancyFullInfo } from '../../utils/types/state-types';
import { receiveVacancy, rejectVacancy, requestVacancy } from '../actions/vacancy-page';

interface IGetVacancyAction {
  type: string;
  payload: {
    vacancyFriendlyUrl?: string;
    vacancyIdForUrl: string;
  }
}

interface ISearchResponse {
  vacancy: IVacancyFullInfo;
}

const getVacancy = function* getVacancy(action: IGetVacancyAction) {
  try {
    let response: ISearchResponse;
    if (action.payload.vacancyFriendlyUrl) {
      response = yield call(getVacancyByFriendlyUrlAPI, action.payload.vacancyFriendlyUrl);
    } else {
      response = yield call(getVacancyByIdForUrlAPI, action.payload.vacancyIdForUrl);
    }
    yield put(receiveVacancy({ vacancy: response }));
  } catch (error) {
    yield put(rejectVacancy({ error }));
  }
};

export default function* getVacancyWatcher() {
  yield takeLatest(requestVacancy, getVacancy);
}
